import { render } from "./Affectations.vue?vue&type=template&id=24542d08"
import script from "./Affectations.vue?vue&type=script&lang=js"
export * from "./Affectations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__